import React from "react";

const BarGraphIcon = () => {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
      <circle
        cx="7"
        cy="7"
        r="6"
        stroke="currentColor"
        strokeWidth="1.2"
      ></circle>
      <path
        d="M7 7L7 1.5M7 7L11 10"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
      ></path>
    </svg>
  );
};

export default BarGraphIcon;
